
  var megamenu_first_link = document.getElementsByClassName("megamenu_first_link");
  var header = document.querySelectorAll(".header")[0];
  var mainContent = document.getElementById("MainContent");


  for(let i=0; i< megamenu_first_link.length; i++) {
     megamenu_first_link[i].onmouseover = function() {
       
       for(let j=0; j< megamenu_first_link.length; j++) {
         megamenu_first_link[j].setAttribute("aria-expanded","false");
         megamenu_first_link[j].parentElement.removeAttribute("open");
     }
       megamenu_first_link[i].setAttribute("aria-expanded","true");
      megamenu_first_link[i].parentElement.setAttribute("open", "");
   }
  }
  header.onclick = function() {
    for(let j=0; j< megamenu_first_link.length; j++) {
         megamenu_first_link[j].setAttribute("aria-expanded","false");
         megamenu_first_link[j].parentElement.removeAttribute("open");
     }
  }
  mainContent.onmouseover = function() {
     for(let j=0; j< megamenu_first_link.length; j++) {
         megamenu_first_link[j].setAttribute("aria-expanded","false");
         megamenu_first_link[j].parentElement.removeAttribute("open");
     }
  }


 window.addEventListener("mouseout", function(event){
  if(event.clientY <= 0 || event.clientX <= 0 || (event.clientX >= window.innerWidth || event.clientY >= window.innerHeight))
  {

    for(let j=0; j< megamenu_first_link.length; j++) {
         megamenu_first_link[j].setAttribute("aria-expanded","false");
         megamenu_first_link[j].parentElement.removeAttribute("open");
     }
  }

  
});
  
